module.exports = __webpack_public_path__ + "static/Mautech-be6bfd6e81be22974b1dc6cc8fc74840.png";